<template>
  <section class="userAccountMsg">
    <p>
      尊敬的 
      <el-dropdown @command="onCommand">
        <span class="el-dropdown-link">
          <span class="name cursor-pointer text-base">{{ name }}</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="editPassword">修改密码</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>，欢迎登录使用。<span class="loginOut" @click="loginOut"
        >退出登录</span
      >
    </p>
    <editPassword ref="editPassword"/>
  </section>
</template>

<script>
// import { mapActions } from "vuex";
import editPassword from './editPassword.vue';
export default {
  data() {
    return {
      name: ""
    };
  },
  created() {
    this.$common
      .http({
        url: "/api/pcenter/detail"
      })
      .then(res => {
        this.name = res.data.data.name;
      });
  },
  components: {
    editPassword
  },
  methods: {
    loginOut() {
      // token 值
      let projectNameArray = window.location.pathname.split("/");
      let projectName = (projectNameArray[1] || "") + "token";
      window.localStorage.removeItem(projectName);
      // 同浏览器的不同tab同时刷新
      window.localStorage.setItem("changeFactory", new Date().getTime());
      this.$router.push("/rhqy/login");
      // this.$common
      //   .http({
      //     url: "/api/authorize/logout",
      //     data: {}
      //   })
      //   .then(() => {
      //     this.$router.push("/rhqy/login");
      //     // 同浏览器的不同tab同时刷新
      //     window.localStorage.setItem("changeFactory", new Date().getTime());
      //   });
    },
    onCommand(command) {
      if (command === "editPassword") {
        this.$refs.editPassword.onOpen();
      }
    }
  }
};
</script>
<style scoped lang="less">
.userAccountMsg {
  padding: 0px 20px;
}
.name {
  color: #b08931;
}
.loginOut {
  color: #1890ff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
